import React from 'react'
import { Modal, Button, Table } from 'react-bootstrap'
import Input from './input'
import ReactMixin from 'react-mixin'
import ImmutableRenderMixin from 'react-immutable-render-mixin'
import createLinkToImmutable from '_/utils/createLinkToImmutable'

/**
 * Bottom navigation component
 */
@ReactMixin.decorate(ImmutableRenderMixin)
class ImprovementModal extends React.Component {
  static propTypes = {
    show: React.PropTypes.bool,
    property: React.PropTypes.object.isRequired,
    improvement: React.PropTypes.object.isRequired,
    onAdd: React.PropTypes.func.isRequired,
    onChange: React.PropTypes.func.isRequired,
    onRemove: React.PropTypes.func.isRequired,
    onHide: React.PropTypes.func
  }

  static contextTypes = {
    store: React.PropTypes.object
  }

  constructor(props, context) {
    super(props, context)
    this.state = {
      isNew: !props.improvement.has('id'),
      improvement: props.improvement,
      link: createLinkToImmutable(this, 'improvement')
    }
  }

  componentWillReceiveProps (props) {
    this.state = {
      isNew: !props.improvement.has('id'),
      improvement: props.improvement,
      link: createLinkToImmutable(this, 'improvement')
    }
  }

  async handleImprovement (evt) {
    evt.preventDefault()
    const { property, onAdd, onChange } = this.props
    const { improvement, isNew } = this.state
    const { store } = this.context

    try {
      if (isNew) {
        this.setState({ disableSubmit: true })
        const newImprovement = await store.post(`/properties/${property.get('id')}/improvements`, improvement)
        onAdd(newImprovement)
      }
      else {
        const updateImprovement = await store.post(`/properties/${property.get('id')}/improvements/${improvement.get('id')}`, improvement)
        onChange(updateImprovement)
      }
    } catch (er) {
      this.setState({
        errors: er.response.body.details
      })
    }

    this.setState({ disableSubmit: false })
  }

  async handleDelete (evt) {
    evt.preventDefault()
    const { property, onRemove } = this.props
    const { improvement } = this.state
    const { store } = this.context

    try {
      await store.delete(`/properties/${property.get('id')}/improvements/${improvement.get('id')}`)
      onRemove(improvement)
    } catch (er) {
      console.error(er)
      this.setState({
        errors: er.response.body.details
      })
    }
  }

  renderAddnFields () {
    const { link } = this.state
    const fields = []

    for (let i = 0; i < 25; i++) {
      fields.push(
        (
          <tr>
            <td><Input type="text" valueLink={link(`addn.${i}.desc`)} name={`addn[${i}].desc`} /></td>
            <td><Input type="text" valueLink={link(`addn.${i}.elem`)} name={`addn[${i}].elem`} /></td>
          </tr>
        )
      )
    }

    return (
      <div>
        <h4>Additional description & data elements</h4>
        <Table bordered className="redi-component-editable-table">
          <thead>
            <tr>
              <th>Description</th>
              <th>Element</th>
            </tr>
          </thead>
          <tbody>
            {fields}
          </tbody>
        </Table>
      </div>
    )
  }

  render () {
    const { show, onHide } = this.props
    const { link, isNew, disableSubmit } = this.state

    return (
      <Modal show={show} onHide={onHide}>
        <Modal.Header closeButton>
          <h3 className="modal-title">{isNew ? 'New' : 'Edit'} improvement</h3>
        </Modal.Header>

        <Modal.Body>
          <Input
            label="Type"
            type="text"
            valueLink={link('type')}
            name="type" />

          <Input
            label="Size"
            type="text"
            valueLink={link('size')}
            name="size" />

          <Input
            label="Construction"
            type="text"
            valueLink={link('const')}
            name="const" />

          <Input
            label="Quality"
            type="text"
            valueLink={link('qual')}
            name="qual" />

          <Input
            label="Foundation"
            type="text"
            valueLink={link('foundation')}
            name="foundation" />

          <Input
            label="Roof"
            type="text"
            valueLink={link('roof')}
            name="roof" />

          <Input
            label="Floor"
            type="text"
            valueLink={link('floor')}
            name="floor" />

          <Input
            label="Exterior"
            type="text"
            valueLink={link('exterior')}
            name="exterior" />

          <Input
            label="Act. age"
            type="text"
            valueLink={link('actAge')}
            name="actAge" />

          <Input
            label="Eff. age"
            type="text"
            valueLink={link('effAge')}
            name="effAge" />

          <Input
            label="Remaining life"
            type="text"
            valueLink={link('remLife')}
            name="remLife" />

          <Input
            label="Condition"
            type="text"
            valueLink={link('cond')}
            name="cond" />

          <Input
            label="Remarks"
            type="textarea"
            valueLink={link('remarks')}
            name="remarks" />

          {this.renderAddnFields()}

          <div className="pull-right">
            {!isNew &&
              <Button
                type="button"
                bsStyle="danger"
                onClick={::this.handleDelete}>
                Delete
              </Button>
            }
          </div>
          <Button
            type="submit"
            disabled={disableSubmit}
            bsStyle="info"
            onClick={::this.handleImprovement}>
            {isNew ? 'Create' : 'Update'} improvement
          </Button>
        </Modal.Body>
      </Modal>
    )
  }
}

export default ImprovementModal



// WEBPACK FOOTER //
// ./modules/shared/components/editImprovementModal.js